module.exports = __webpack_public_path__ + "img/refresh.4a61d480.svg";